import React, { useEffect, useState } from 'react';
import { Modal }                      from 'react-responsive-modal';
import apiFetch                       from '@wordpress/api-fetch';
import LoggingService                 from '../Services/LoggingService';
import jqXHR = JQuery.jqXHR;

// Local cfwAjax that uses window.cfw_post_purchase_data
const cfwPostPurchaseAjax = ( id: string, params: JQuery.AjaxSettings ): JQuery.jqXHR<any> => {
    LoggingService.logNotice( `AJAX request to endpoint: ${id}. ☄️` );

    const defaultErrorFunction = ( xhr: JQuery.jqXHR, textStatus: string, errorThrown: string ): void => {
        if ( textStatus !== 'abort' ) {
            LoggingService.logError( `cfwAjax ${id} Error: ${errorThrown} (${textStatus})` );
        }
    };

    const args     = { ...params };
    const postPurchaseData = (window as any).cfw_post_purchase_data;
    const endpoint = postPurchaseData?.checkout_params?.wc_ajax_url?.toString().replace( '%%endpoint%%', id );
    args.url       = `${endpoint}&nocache=${new Date().getTime()}`;
    args.dataType  = 'json';
    args.cache     = false;
    args.error     = [ params.error, defaultErrorFunction ].filter( Boolean ).flat(); // ensures 1d array of callbacks

    return jQuery.ajax( args );
};

const PostPurchaseBumps = () => {
    console.log( '[CFW Post Purchase] Component mounting' );
    console.log( '[CFW Post Purchase] Initial window.cfw_post_purchase_data:', (window as any).cfw_post_purchase_data );

    const [ isOpen, setOpen ] = useState( true );
    const [ content, setContent ] = useState( '' );
    const [ fullScreen, setFullScreen ] = useState( false );
    const [ isLoading, setIsLoading ] = useState( true );

    const syncPrice = ( e: Event ) => {
        const form = jQuery( e.currentTarget as HTMLElement );
        const updatedPrice = form.find( '.single_variation_wrap .woocommerce-variation-price' ).html();

        if ( updatedPrice ) {
            form.find( '.cfw-product-form-modal-price' ).html( updatedPrice );
        }
    };

    const fetchBumpContent = async () => {
        console.log( '[CFW Post Purchase] fetchBumpContent called' );
        const bumpData = (window as any).cfw_post_purchase_data;

        console.log( '[CFW Post Purchase] Bump data check:', {
            hasBumpData: !!bumpData,
            hasCurrentBump: !!bumpData?.current_bump,
            bumpData,
        } );

        if ( !bumpData || !bumpData.current_bump ) {
            console.warn( '[CFW Post Purchase] No bump data or current_bump found, aborting' );
            setIsLoading( false );
            return;
        }

        const bumpId = bumpData.current_bump.id;
        const isFullScreen = bumpData.current_bump.full_screen;

        console.log( '[CFW Post Purchase] Fetching bump content:', {
            bumpId,
            isFullScreen,
        } );

        setFullScreen( isFullScreen );

        try {
            let url = '';
            if ( isFullScreen ) {
                // For full screen, get the full post content
                url = `wp/v2/cfw_order_bumps/${bumpId}`;
            } else {
                // For standard modal, get the product form
                url = `checkoutwc/v1/post-purchase-order-bump-upsell-product-form/${bumpId}`;
            }

            console.log( '[CFW Post Purchase] API fetch URL:', url );
            const response = await apiFetch( { path: url } ) as any;
            console.log( '[CFW Post Purchase] API response received:', response );

            if ( isFullScreen && response.content?.rendered ) {
                console.log( '[CFW Post Purchase] Setting full screen content' );
                setContent( response.content.rendered );
            } else if ( !isFullScreen && response.html ) {
                console.log( '[CFW Post Purchase] Setting standard modal content' );
                setContent( response.html );
            } else {
                console.warn( '[CFW Post Purchase] Response missing expected content format:', response );
                setContent( '<p>Could not load offer content.</p>' );
            }
        } catch ( error ) {
            console.error( '[CFW Post Purchase] Error fetching bump content:', error );
            LoggingService.logError( 'Error fetching post-purchase bump content:', error );
            setContent( '<p>Could not load offer content.</p>' );
        } finally {
            console.log( '[CFW Post Purchase] Fetch complete, setting isLoading to false' );
            setIsLoading( false );
        }
    };

    const handleBumpFormSubmit = ( e: Event ): jqXHR | void => {
        e.preventDefault();

        const form = jQuery( e.currentTarget as HTMLElement );
        const button = form.find( 'button[type="submit"]' );

        // Check if already processing
        if ( button.hasClass( 'loading' ) || button.prop( 'disabled' ) ) {
            return;
        }

        // Immediately disable button and add loading state
        button.prop( 'disabled', true ).addClass( 'loading' );

        const productData = form.serializeArray();

        // Check for product ID
        let hasProductId = false;
        jQuery.each( productData, ( key, formItem ) => {
            if ( formItem.name === 'productID' || formItem.name === 'add-to-cart' ) {
                if ( formItem.value ) {
                    hasProductId = true;
                    return false;
                }
            }
            return true;
        } );

        let productID: string | boolean = false;

        // If no product id found, look for the form action URL
        if ( !hasProductId && form.attr( 'action' ) ) {
            const isUrl = form.attr( 'action' ).match( /add-to-cart=([0-9]+)/ );
            productID = isUrl ? isUrl[ 1 ] : false;
        }

        // If button has name add-to-cart get it and add to form
        if ( button.attr( 'name' ) && button.attr( 'name' ) === 'add-to-cart' && button.attr( 'value' ) ) {
            productID = button.attr( 'value' );
        }

        if ( productID ) {
            productData.push( { name: 'add-to-cart', value: productID } );
        }

        button.addClass( 'loading' );

        // Trigger event
        jQuery( document.body ).trigger( 'adding_to_cart', [ button, productData ] );

        return handleOneClickAccept( form, button, productID as string, productData );
    };

    const handleOneClickAccept = ( form: JQuery<HTMLElement>, button: JQuery<HTMLElement>, productID: string, productData: any[] ): jqXHR => {
        const bumpData = (window as any).cfw_post_purchase_data;
        if ( !bumpData ) {
            return jQuery.Deferred().reject().promise() as jqXHR;
        }

        // Get bump ID from form or data
        const bumpId = form.find( 'input[name="cfw_ob_id"]' ).val() || bumpData.current_bump.id;

        // Get product details
        const variationId = form.find( 'input[name="variation_id"]' ).val() || '0';
        const qty = form.find( 'input[name="quantity"]' ).val() || '1';

        return cfwPostPurchaseAjax( 'cfw_process_offer_payment', {
            type: 'POST',
            data: {
                order_id: bumpData.order.id,
                order_key: bumpData.order.key,
                bump_id: bumpId,
                product_id: productID,
                variation_id: variationId,
                qty,
                _wpnonce: bumpData.current_bump.nonce,
            },
            dataType: 'json',
            cache: false,
        } ).done( ( resp ) => {
            button.removeClass( 'loading' );

            if ( !resp.success ) {
                // Payment failed but not a system error - show message
                alert( resp.message || 'Payment failed. Please try again.' );
                button.prop( 'disabled', false );
                return;
            }

            jQuery( document.body ).trigger( 'cfw_post_purchase_upsell_accepted', [ resp ] );
            window.location.reload();
        } ).fail( ( jqXHR, textStatus, errorThrown ) => {
            // System error - stop showing offers
            button.removeClass( 'loading' );
            LoggingService.logError( 'Post-purchase payment failed:', errorThrown );

            // Go to thank you page (session will clear automatically)
            window.location.href = bumpData.thank_you_url;
        } );
    };

    const handleDecline = async () => {
        const bumpData = (window as any).cfw_post_purchase_data;
        if ( !bumpData ) {
            return;
        }

        try {
            await cfwPostPurchaseAjax( 'cfw_decline_offer', {
                type: 'POST',
                data: {
                    bump_id: bumpData.current_bump.id,
                    order_id: bumpData.order.id,
                    order_key: bumpData.order.key,
                    _wpnonce: bumpData.current_bump.nonce,
                },
                dataType: 'json',
            } );

            // Success - reload to show next or complete
            window.location.reload();
        } catch ( error ) {
            LoggingService.logError( 'Error declining offer:', error );

            // Error - stop showing offers and go to thank you page
            // Session will clear automatically when page loads
            window.location.href = bumpData.thank_you_url;
        }
    };

    useEffect( () => {
        console.log( '[CFW Post Purchase] useEffect - Initial mount, fetching bump content' );
        // Auto-open modal and fetch content on mount
        fetchBumpContent();

        // Set up event handlers
        const modalId = 'cfw-post-purchase-modal';
        console.log( '[CFW Post Purchase] Setting up event handlers' );

        jQuery( document.body ).on( `submit.${modalId}`, `.${modalId} form.cfw-modal-order-bump-form`, handleBumpFormSubmit );
        jQuery( document.body ).on( `woocommerce_variation_has_changed.${modalId}`, `.${modalId} form`, syncPrice );
        jQuery( document.body ).on( `wc_variation_form.${modalId}`, `.${modalId} form`, syncPrice );
        jQuery( document.body ).on( `show_variation.${modalId}`, syncPrice );
        jQuery( document.body ).on( `show_variation.${modalId}`, ( event, variation, purchasable ) => {
            const addToCartButton = jQuery( '.cfw-modal .single_add_to_cart_button' );

            if ( purchasable ) {
                addToCartButton.prop( 'disabled', false );
                return;
            }

            addToCartButton.prop( 'disabled', true );
        } );
        jQuery( document.body ).on( `reset_data.${modalId}`, () => {
            jQuery( '.cfw-modal .single_add_to_cart_button' ).prop( 'disabled', true );
        } );
        jQuery( document.body ).on( `click.${modalId}`, `.${modalId} .cfw-bump-reject`, handleDecline );

        return () => {
            console.log( '[CFW Post Purchase] Component unmounting, cleaning up event handlers' );
            // Clean up event handlers
            jQuery( document.body ).off( `.${modalId}` );
        };
    }, [] );

    useEffect( () => {
        console.log( '[CFW Post Purchase] useEffect - Content/loading state changed:', {
            isLoading,
            hasContent: !!content,
            contentLength: content?.length,
        } );

        // Initialize variation forms after content loads
        if ( !isLoading && content ) {
            console.log( '[CFW Post Purchase] Initializing variation forms' );
            setTimeout( () => {
                const form = jQuery( 'form.cfw-product-form-modal.variable' );
                console.log( '[CFW Post Purchase] Variable forms found:', form.length );
                if ( form.length ) {
                    form.wc_variation_form();
                }
            }, 100 );
        }
    }, [ isLoading, content ] );

    console.log( '[CFW Post Purchase] Render decision:', {
        isLoading,
        hasContent: !!content,
        isOpen,
    } );

    if ( isLoading ) {
        console.log( '[CFW Post Purchase] Rendering loading modal' );
        return (
            <Modal
                open={isOpen}
                onClose={() => null}
                classNames={{
                    root: 'cfw-modal-root',
                    overlay: 'cfw-modal-overlay',
                    modal: 'cfw-modal cfw-post-purchase-modal-loading',
                    modalContainer: 'cfw-modal-container',
                }}
                showCloseIcon={false}
                focusTrapped={false}
                blockScroll={true}
                center={true}
            >
                <div className="cfw-modal-loading-spinner">Loading offer...</div>
            </Modal>
        );
    }

    if ( !content ) {
        console.log( '[CFW Post Purchase] No content, rendering null' );
        return null;
    }

    console.log( '[CFW Post Purchase] Rendering full modal with content' );
    return (
        <Modal
            open={isOpen}
            onClose={() => null}
            classNames={{
                root: 'cfw-modal-root',
                overlay: 'cfw-modal-overlay',
                modal: `cfw-modal cfw-grid cfw-post-purchase-modal ${fullScreen ? 'cfw-full-screen' : ''}`,
                modalContainer: 'cfw-modal-container',
            }}
            showCloseIcon={false}
            focusTrapped={false}
            blockScroll={true}
            center={!fullScreen}
        >
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </Modal>
    );
};

export default PostPurchaseBumps;
